import api from "@/apis/UserSystem/RoleAPI";
import Crud from "./crud-base";
var crud = new Crud("role", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "RoleID",
      code: "RoleCode",
      name: "RoleName",
    },
    /**
     * loading user
     */
    loadingDetailUser: false,

    //Danh sách từ databse lên
    listDetailUserOrigin: [],
  },
};
const getters = {
  ...crud.getters,
};
const mutations = {
  ...crud.mutations,

  //Update lại trạng thái loading của lưới chi tiết người dùng trên danh sách vai trò
  updateLoadingUser(state, data) {
    state.loadingDetailUser = data;
  },

  //Cập nhật danh sách người dùng gốc (chưa lọc) vào state
  setListDetailUserOrigin(state, res) {
    if (state.listDetailUserOrigin && Array.isArray(state.listDetailUserOrigin)) {
      state.listDetailUserOrigin.removeAll();
    }
    state.listDetailUserOrigin = res;
    //Thêm vào danh sách  này để khi sửa chi tiết role thì mặc định sẽ có luôn
  },

  /**
   * Cập nhật khi xóa bản ghi người dùng khỏi người dùng thuộc role
   */
  deleteItemsDetailUserOrigin(state, items) {
    let keyField = "UserJoinRoleID";

    if (keyField) {
      let count = items.length;
      for (let k = 0; k < count; k++) {
        let id = items[k][keyField];
        for (let i = 0; i < state.listDetailUserOrigin.length; i++) {
          let item = state.listDetailUserOrigin[i];

          if (item[keyField] === id) {
            state.listDetailUserOrigin.remove(item);
            break;
          }
        }
      }

      state.total -= count;
    }
  },
};

const actions = {
  ...crud.actions,

  /**
   * Load danh sách người dùng theo role
   */
  async getListUserByRoleID(context, payload) {
    context.commit("updateLoadingUser", true);

    let res = await api.getListUserByRoleID(payload || {});
    context.commit("updateLoadingUser", false);

    if (res) {
      context.commit("setListDetailUserOrigin", res);
    }
    return res;
  },
  //Từ action gọi vào mutation để cập nhật storage danh sách người dùng từ form chọn nhân viên
  commitListDetailUserOrigin(context, res) {
    context.commit("setListDetailUserOrigin", res);
  },

  /**
   * Xóa
   */
  async deleteUserInrole(context, payload) {
    let res = await api.deleteUserInrole(payload);
    if (res && res.Success) {
      //cập nhật danh sách
      let deleteSucessItems = payload.Entity;
      context.commit("deleteItemsDetailUserOrigin", deleteSucessItems);
    }
    return res;
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
